
import React from 'react';
import {Box, Grid, MenuItem, Select, TextField, Typography} from '@mui/material';

function FilterControls({ uniqueRegionNames, uniqueContinentNames, regionFilter, setRegionFilter, cloudProviderQuery, setCloudProviderQuery: setCloudProviderQuery, continentFilter, setContinentFilter }) {
  const cloudProviders = [ "AWS", "Azure", "GCP" ]
  return (
   <Box sx={{ padding: 2, backgroundColor: '#f9f9f9', borderRadius: '8px' }}>
   <Grid container spacing={3} alignItems="center">
     <Grid item xs={12} sm={6}>
       <Typography variant="body-1">
         Filter By Cloud Provider:
       </Typography>
       <Select
           value={cloudProviderQuery}
           onChange={(e) => setCloudProviderQuery(e.target.value)}
           variant="outlined"
           fullWidth
       >
         {Array.from(cloudProviders).map((cloudProvider) => (
             <MenuItem key={cloudProvider} value={cloudProvider}>
               {cloudProvider}
             </MenuItem>
         ))}
       </Select>
     </Grid>
      <Grid item xs={12} sm={6}>
        <Typography variant="body-1">
          Filter by Continent:
        </Typography>
        <Select
          value={continentFilter}
          onChange={(e) => setContinentFilter(e.target.value)}
          variant="outlined"
          fullWidth
        >
          {Array.from(uniqueContinentNames).map((continent) => (
            <MenuItem key={continent} value={continent}>
              {continent}
            </MenuItem>
          ))}
        </Select>
      </Grid>
  </Grid>
</Box>

  );
}

export default FilterControls;
